import { storeInfo } from '@/constants/site'

const priceFormatter = new Intl.NumberFormat(storeInfo.locale, {
    style: 'currency',
    currency: storeInfo.currency
})

export const formatPrice = (value: number): string => priceFormatter.format(value)

/*
 * Formats a YYYY-MM-DD pickup date. Noon UTC keeps the weekday stable no
 * matter which time zone renders it.
 */
export const formatPickupDate = (value: string): string => {
    const date = new Date(`${value}T12:00:00Z`)

    if (Number.isNaN(date.getTime())) return value

    return date.toLocaleDateString(storeInfo.locale, {
        weekday: 'long',
        month: 'long',
        day: 'numeric',
        timeZone: 'UTC'
    })
}

export const pluralize = (count: number, singular: string, plural = `${singular}s`): string => {
    return count === 1 ? singular : plural
}
